import { connect } from 'react-redux'
import { Row, Col, Tooltip, Descriptions } from 'antd'
import { getNodeLabel } from 'Services/WeaverUtils'
import { getFormattedAttributeValue, isDownloadable } from './shared'
import WeaverService from 'Services/WeaverService'
import ColorService from 'Services/ColorService'
import Feather from '@sysunite/react-feather'
import { setEditingNode } from 'Actions/explore'
import { TransformAttrToRel } from 'Components'

const DetailsContainer = ({
  item,
  title,
  type,
  children,
  nodeIsEditable
}) => {
  const EditIcon = ({ setEditingNode }) => {
    if (WeaverService.userCanEdit() && (item != null && item.nodeId != null)) {
      return (
        <Feather
          onClick={() => setEditingNode(item)}
          style={{
            float: 'right',
            marginRight: 15,
            marginTop: 3,
            cursor: 'pointer'
          }}
          type="edit"
          data-testid="edit-attributes"
        />
      )
    } else {
      return null
    }
  }

  const ConnectedEditIcon = connect(undefined, { setEditingNode })(EditIcon)
  const color = ColorService.getColorForType(type ? type.id() : null)

  return (
    <Descriptions
      title={(
        <Row>
          <Col style={{ flex: 'auto' }}>
            <Tooltip
              arrowPointAtCenter={true}
              placement="bottomLeft"
              title={getNodeLabel(type)}
            >
              <Feather style={{ fill: color, color }} type="circle" />
            </Tooltip>
            { title }
          </Col>
          { nodeIsEditable && <ConnectedEditIcon /> }
        </Row>
      )}
      column={1}
      size="small"
      className="attributes-container"
    >
      {
        children.map(({ key, label, value, rowIsEditable = true }) => (
          <Descriptions.Item
            label={label}
            key={key}
          >
            {(() => {
              if (nodeIsEditable && rowIsEditable && !isDownloadable(type, key, value)) {
                return (<>
                  { getFormattedAttributeValue(value, key, item.getDataType(key)) }
                  <a className="edit-attr-and-rel-key-icon" style={{ float: 'right' }}>
                    <TransformAttrToRel
                      value={value}
                      label={key}
                      type="NODE"
                      nodeId={type?.id()}
                    />
                  </a>
                </>)
              } else if (item instanceof Weaver.Node) {
                return getFormattedAttributeValue(value, key, item.getDataType(key), type)
              } else {
                return value
              }
            })()}
          </Descriptions.Item>
        ))
      }
    </Descriptions>
  )
}

export default DetailsContainer
